export enum RentalReservationDocumentTypeEnum {
  GovernmentId = 'GovernmentId',
  Additional = 'Additional',
}

export const rentalReservationDocumentTypeMap: Record<RentalReservationDocumentTypeEnum, string> = {
  [RentalReservationDocumentTypeEnum.GovernmentId]: 'Government Photo ID',
  [RentalReservationDocumentTypeEnum.Additional]: 'Additional Document',
};
